import React, { useState } from 'react'
import { useAuth } from './AuthContext'
import PasswordInput from '../components/ui/PasswordInput'

const IconCheck = ({size=20,className=""}) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M20 6 9 17l-5-5"/></svg>

export default function SetPasswordScreen() {
  const { user, completePasswordSetup, signOut } = useAuth()
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    if (password.length < 6) { setError('Password must be at least 6 characters'); return }
    if (password !== confirm) { setError('Passwords do not match'); return }
    setLoading(true)
    try {
      await completePasswordSetup(password)
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-white tracking-wide">BEATY</h1>
          <p className="text-slate-400 mt-1">Brothers Moving System</p>
        </div>
        <div className="bg-white rounded-xl shadow-xl p-8">
          <div className="text-center mb-6">
            <div className="w-14 h-14 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3">
              <IconCheck size={28} className="text-green-600"/>
            </div>
            <h2 className="text-xl font-bold text-slate-900">Welcome to BBM!</h2>
            <p className="text-sm text-slate-500 mt-1">Set a password so you can sign in anytime.</p>
          </div>
          {error && <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">{error}</div>}
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block text-sm font-medium text-slate-700 mb-1">Email</label>
              <input type="email" disabled value={user?.email || ''} className="w-full border border-slate-200 rounded-lg px-3 py-2.5 text-sm bg-slate-50 text-slate-500" />
            </div>
            <div className="mb-4">
              <label className="block text-sm font-medium text-slate-700 mb-1">Create Password</label>
              <PasswordInput required minLength="6" value={password} onChange={e => setPassword(e.target.value)} className="w-full border border-slate-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent" placeholder="Min 6 characters" autoFocus />
            </div>
            <div className="mb-6">
              <label className="block text-sm font-medium text-slate-700 mb-1">Confirm Password</label>
              <PasswordInput required minLength="6" value={confirm} onChange={e => setConfirm(e.target.value)} className="w-full border border-slate-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent" placeholder="Re-enter password" />
            </div>
            <button type="submit" disabled={loading} className="w-full bg-red-600 hover:bg-red-700 text-white py-2.5 rounded-lg text-sm font-medium disabled:opacity-50">
              {loading ? 'Setting up...' : 'Set Password & Continue'}
            </button>
          </form>
          <div className="mt-4 text-center">
            <button onClick={signOut} className="text-xs text-slate-400 hover:text-slate-600">Sign out</button>
          </div>
        </div>
        <p className="text-center text-slate-500 text-xs mt-6">Beaty Brothers Moving • Nashville, TN</p>
      </div>
    </div>
  )
}
